import { Badge } from "../../ui/badge";

const m = (v) => `$${Number(v || 0).toFixed(2)}`;

export const settledViaWorkflow = (b) => Boolean(b?.settlement_completed_at);

export const adoptedFromHistory = (c) =>
  Boolean(c.settlement_adopted_key || (c.edit_history || []).some((h) => h.source === "settlement_legacy_correction"));

// Canonical bond position after a confirmed settlement (same fields the Settlement tab uses).
export function SettledBondLine({ booking: b }) {
  const used = Number(b.bond_charges_deducted_total || 0);
  const refunded = Number(b.bond_refund_amount || 0);
  const retained = Number(b.bond_deduction_amount || 0);
  const remaining = b.bond_closed ? 0 : Math.max(Number(b.deposit_amount || 0) - used - refunded - retained, 0);
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1" data-testid="details-settled-bond-line">
      <span><strong className="text-[#B23A48]" data-testid="details-bond-used">{m(used)} used for charges</strong></span>
      <span className="text-[#676664]">·</span>
      <span><strong className="text-[#0E7C5A]" data-testid="details-bond-refunded">{m(refunded)} refunded</strong></span>
      {retained > 0 && <><span className="text-[#676664]">·</span><span><strong className="text-[#B23A48]" data-testid="details-bond-retained">{m(retained)} retained</strong></span></>}
      <span className="text-[#676664]">·</span>
      <span data-testid="details-bond-remaining">{m(remaining)} remaining</span>
      <span className="text-[10px] text-[#676664]/60">(as settled)</span>
    </div>
  );
}

export function ChargeSettlementBadges({ c }) {
  return (
    <>
      {c.settlement_locked && <Badge className="bg-[#282828] text-white border-[#282828] border text-[9px]" data-testid={`charge-locked-badge-${c.id}`}>Locked — settled</Badge>}
      {c.charge_type === "rental_adjustment" && <Badge className="bg-white text-[#9A7B4F] border-[#9A7B4F]/30 border text-[9px]" data-testid={`charge-rent-diff-badge-${c.id}`}>Rent difference · part of rent</Badge>}
      {c.charge_type !== "rental_adjustment" && adoptedFromHistory(c) && <Badge className="bg-white text-[#0E7C5A] border-[#0E7C5A]/30 border text-[9px]" data-testid={`charge-settled-badge-${c.id}`}>Settled · from history</Badge>}
    </>
  );
}
